import React, { useContext } from "react";
import { PatientGoal } from "../../goal_templates/classes/patient_goal_class";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { ActivationModalControls } from "../common/components/activationModalControls";

export const GoalDeactivationContainer = ({ selection, closeModal }) => {
  const {
    selectedPatientGoals,
    setSelectedPatientGoals,
    setModalStatus,
    t,
  } = useContext(TMDataContext);

  var goal;

  if (selection.type.name.includes("GoalTemplate")) {
    goal = PatientGoal.findByTemplateId(selection.id);
  }

  if (selection.type.name.includes("PatientGoal")) {
    goal = selection;
  }

  const deactivateGoal = () => {
    if (!goal.isExistingGoal()) {
      goal.name = goal.goalTemplate.name;
    }
    goal.selectForDeletion();
    setSelectedPatientGoals((currentSelection) =>
      removeGoalSelection(currentSelection)
    );
    setModalStatus("deactivate");
    closeModal();
  };

  const removeGoalSelection = (currenSelection) => {
    let updatedSelection = currenSelection.filter(
      (savedGoal) => savedGoal != goal
    );
    return updatedSelection;
  };

  const displayWarning = () => {
    return (
      <>
        <span>{t("views.goals.navigation.remove_patient_goal_prompt")}</span>
        <span>
          {t("views.goals.navigation.remove_patient_goal_prompt_followup")}
        </span>
      </>
    );
  };

  return (
    <div className="patient-goal-deactivation-modal">
      <div className="patient-goal-modal-container ">
        <div className="patient-goal-preview-title goal-preview-warning">
          <span>{t("views.referral.dialog.make_selection")}</span>
        </div>
        <div className="patient-goal-deactivation-contents">
          {displayWarning()}
        </div>
        <div className="patient-goal-footer-block">
          <ActivationModalControls
            hasErrors={false}
            actionLabel="remove"
            action={deactivateGoal}
            closeModal={closeModal}
          />
        </div>
      </div>
    </div>
  );
};
